import { observer } from 'mobx-react-lite'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useComplianceLayerContext } from 'pages/settings/pages/compliance/context'
import { useProgressInfoTitle } from 'pages/settings/pages/compliance/pages/international/hooks/useProgressInfoTitle'
import { useLayoutTitle } from 'pages/settings/pages/compliance/pages/international/hooks/useLayoutTitle'
import {
  InternationalStepsProvider,
  useInternationalStepsContext,
} from 'pages/settings/pages/compliance/pages/international/context/internationalStepsContext'
import { type InternationalRoutes } from 'pages/settings/pages/compliance/pages/international'

export const InternationalLayoutContent = observer(() => {
  const {
    stepsStore: { step, totalSteps },
    closeSetting,
    decreaseStep,
  } = useInternationalStepsContext()

  return (
    <StepsCommonLayout
      progressTitle={useProgressInfoTitle()}
      totalSteps={totalSteps}
      title={useLayoutTitle()}
      settingsStep={step}
      closeSetting={closeSetting}
      decreaseStep={(lastPathSegment) => decreaseStep(lastPathSegment as InternationalRoutes)}
    />
  )
})

export const InternationalStepsLayout = () => {
  const complianceLayerStore = useComplianceLayerContext()

  return (
    <InternationalStepsProvider complianceLayerStore={complianceLayerStore}>
      <InternationalLayoutContent />
    </InternationalStepsProvider>
  )
}
